module.exports = __webpack_public_path__ + "img/cvganador.a83def55.png";